
  import { Component, Vue,Inject,Prop } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    private index = 0
    @Inject() information:any
    get value(){
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      let msg = this.information.find(v=>{
        return v.key == this.modekey
      })
      // if(msg&&msg.underModule&&msg.underModule.length){
      //   this.activeName = msg.underModule[0].key
      // }
      return msg
    }
    private tap(i){
      this.index = i
    }
    private getrandom(){
      return Date.now()+''
    }
  }
